<form [formGroup]="formulario">

    <input style="display: none;" formControlName="idSolicitacao" matInput type="text">

    <input style="display: none;" formControlName="idResponsavel" matInput type="text">

    <input style="display: none;" formControlName="idDepartamento" matInput type="text">

    <input style="display: none;" formControlName="idFilialFocus" matInput type="text">

    <input style="display: none;" formControlName="idTipoServico" matInput type="text">

    <input style="display: none;" formControlName="Status" matInput type="text">

    <input style="display: none;" formControlName="Responsavel" matInput type="text">

    <div class="row">

        <div class="col-sm-6 col-12">
    
            <mat-form-field style="width: 100%">
                <mat-label>Departamento</mat-label>
                <mat-select (selectionChange)="mudaIdDepartamento($event)" formControlName="Departamento">
                  <mat-option  #valor *ngFor="let n of Departamentos" [value]="n.value">
                    {{n.viewValue}}
                  </mat-option>
                </mat-select>
            </mat-form-field>
    
            <mat-form-field *ngIf="formulario.get('idDepartamento').value != 0" style="width: 100%">
                <mat-label>Tipo de Serviço</mat-label>
                <mat-select (selectionChange)="mudaIdTipoServico($event)" formControlName="TipoServico">
                  <mat-option  #valor *ngFor="let n of TiposServico" [value]="n.value">
                    {{n.viewValue}}
                  </mat-option>
                </mat-select>
            </mat-form-field>

        </div>

        <div class="col-sm-6 col-12">

            <mat-form-field style="width: 100%">
                <mat-label>Filiais</mat-label>
                <mat-select (selectionChange)="mudaIdFilial($event)" formControlName="FilialFocus"> 
                  <mat-option *ngFor="let n of Filiais" [value]="n.value">
                    {{n.viewValue}}
                  </mat-option>
                </mat-select>
            </mat-form-field>     
       
            <mat-form-field style="width: 100%;" class="caixa-texto">
                <mat-label>Prazo</mat-label>
                <input formControlName="Prazo" matInput type="date">
            </mat-form-field>
   
        </div>        

    </div>

    <mat-label>Solicitação</mat-label>
    <pre><textarea style="height: 150px" formControlName="Solicitacao" class="form-control" aria-label="With textarea"></textarea></pre>

</form>

<div [ngClass]="larguraPagina > 500 ? 'd-flex justify-content-end' : ''">
  <button [ngClass]="larguraPagina > 500 ? 'btn btn-primary mr-2' : 'btn btn-primary btn-block' " (click)="gravar()" [disabled]="formulario.status == 'INVALID' ? true : false">Adicionar Pendência</button>
  <button [ngClass]="larguraPagina > 500 ? 'btn btn-danger' : 'btn btn-danger btn-block'" (click)="fechar()">Cancelar</button>
</div>